import { createElement, Component, Props as ReactProps } from 'react';
import styled from 'styled-components';
import {
  NO_IMAGE_URL,
} from '../../constants';

type Props = ReactProps<HTMLElement> & {
  src: string;
  errSrc?: string;
  className?: string;
  onError?: () => void;
};

type State = {
  isError: boolean;
};

const Root = styled.div`
  position: relative;
`;

const SelfImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

class Image extends Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      isError: false,
    };

    this.onError = this.onError.bind(this);
  }

  public componentWillReceiveProps (nextProps: Props) {
    if (this.props.src !== nextProps.src) {
      this.setState({
        isError: false,
      });
    }
  }

  public render () {
    const { src, errSrc, className } = this.props;
    const imgSrc = ((errSrc || NO_IMAGE_URL) && this.state.isError) ? (errSrc || NO_IMAGE_URL) : src;

    return (
      <Root className={className}>
        <SelfImage
          src={imgSrc}
          onError={() => this.onError()}
        />
      </Root>
    );
  }

  private onError () {
    if (!this.state.isError) {
      this.setState({ isError: true });
    }

    if (this.props.onError) {
      this.props.onError();
    }
  }
}

export default Image;
